import * as R from 'ramda'
import {
    ADD_KEY_LIST_SUCCESS
} from '../actionTypes'

const InitialState = '';

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case ADD_KEY_LIST_SUCCESS:
            return payload
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/keyList.js